<template>
  <v-card
    class="ma-0 pa-0"
    style="overflow: hidden"
    height="calc(100vh - 100px)"
  >
    <WindowFrame
      class="ma-0 pa-0"
      referrerpolicy="origin"
      ref="windowframe_magazzino"
      :component="'magazzino'"
      :input_args="input_args"
      @click_chiudi="gotoDashboard"
      @loaded="sendParamsMag"
    />
  </v-card>
</template>

<script>
import WindowFrame from "@/components/WINDOWFRAME/WindowFrame.vue";

export default {
  name: "Menu",
  components: { WindowFrame },
  props: {
    id_modulo_menu: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      input_args: { id_modulo_menu: Number(this.id_modulo_menu) },
    };
  },
  computed: {},
  methods: {
    sendParamsMag() {
      this.$refs.windowframe_magazzino.postEvent("setparams", {
        param_1: "Prova",
        cod_azienda: localStorage.getItem("cod_azienda"),
        id_azienda: localStorage.getItem("id_azienda"),
        route: "/home",
      });
    },

    gotoDashboard() {
      this.$router.push("/home/production");
    },
  },
};
</script>